export enum LocalAppointmentStatus {
  CHECK_IN = 'Check-in',
  CHECKED_IN = 'Checked-in',
  IN_CONSULTATION = 'In Consultation',
  DELAYED = 'Delayed',
  COMPLETED = 'Completed',
  UNKNOWN = 'Unknown',
}
